import { Alert, Button } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';

interface ConnectionBannerProps {
  visible: boolean;
  onRetry: () => void;
  message?: string;
}

export default function ConnectionBanner({
  visible,
  onRetry,
  message = 'Having trouble loading. Showing the last available data.',
}: ConnectionBannerProps) {
  if (!visible) return null;

  return (
    <Alert
      type="warning"
      showIcon
      style={{ margin: 0, textAlign: 'left', width: '100%' }}
      message={message}
      action={
        <Button size="small" icon={<ReloadOutlined />} onClick={onRetry}>
          Retry
        </Button>
      }
    />
  );
}
